import React, { useEffect, useState } from 'react';
import apiService from '../../services/api';

interface VehicleImage {
  id: string;
  file_name: string;
  file_path: string;
  is_primary: boolean;
  display_order: number;
}

interface VehicleThumbnailProps {
  vehicleId: string;
  year: number;
  make: string;
  model: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

const VehicleThumbnail: React.FC<VehicleThumbnailProps> = ({
  vehicleId,
  year,
  make,
  model,
  className = '',
  size = 'medium',
}) => {
  const [primaryImage, setPrimaryImage] = useState<string | null>(null);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const fetchVehicleImages = async () => {
      try {
        const images = await apiService.get<VehicleImage[]>(
          `/vehicles/${vehicleId}/vehicle-images`
        );
        if (images && images.length > 0) {
          const primary = images.find((img) => img.is_primary) || images[0];
          setPrimaryImage(apiService.getFileUrl(primary.file_path));
        }
      } catch (err) {
        console.error('Failed to fetch vehicle images:', err);
      }
    };

    fetchVehicleImages();
  }, [vehicleId]);

  const sizeClasses = {
    small: 'w-12 h-9',
    medium: 'w-16 h-12',
    large: 'w-20 h-15',
  };

  const textSizeClasses = {
    small: 'text-xs',
    medium: 'text-xs',
    large: 'text-sm',
  };

  if (!primaryImage || imageError) {
    return (
      <div
        className={`${sizeClasses[size]} bg-gray-200 rounded flex items-center justify-center ${className}`}
      >
        <span className={`${textSizeClasses[size]} text-gray-500`}>No Image</span>
      </div>
    );
  }

  return (
    <img
      src={primaryImage}
      alt={`${year} ${make} ${model}`}
      className={`${sizeClasses[size]} object-cover rounded border border-gray-200 ${className}`}
      onError={() => setImageError(true)}
    />
  );
};

export default VehicleThumbnail;
